// for panorama
//https://pchen66.github.io/Panolens/#Home

console.log = function () {}
console.warn = function () {}

import * as THREE from 'three';
import * as PANOLENS from 'panolens';
import * as SpriteSpin from "spritespin";

var lookAtPositions = [
	new THREE.Vector3(30, 3, 2),
	//new THREE.Vector3(4871.39, 1088.07, -118.41),

];

var panorama, viewer, container, infospot;




$(function () {

	let panoramaImg = [];
	let panorama = [];
	let initedPanoram = false;
	// $('.threeDWrapp .tab-content:not(:first)').hide();
	$('.threeDWrapp .tabs360Toggle a').on('click', function (e) {

		e.preventDefault();
		let $this = $(this);
		let targetType = $(this).data('type');
		let target = $(this).attr('href');

		$('.threeDWrapp .tabs360Toggle a.active').removeClass('active');
		$this.addClass('active');

		$('.threeDWrapp .tab-pane').removeClass('showMe')
		$(target).addClass('showMe')
		window.ScrollTopTo($(target))

		//$('.panoramContainer').html('')







		if (targetType == 'panorama') {
			showLoading();

			let panoramas = document.querySelectorAll('.threeDWrapp .tabs360Toggle a[data-type="panorama"]');

			// init the panorama for the first toime
			if (!initedPanoram) {


				container = document.querySelector('.panoramContainer');

				viewer = new PANOLENS.Viewer({
					container: container,
					controlButtons: ['fullscreen']
				});

				for (var i = 0; i < panoramas.length; i++) {
					panoramaImg.push(panoramas[i].getAttribute('data-panorama'));
					panorama.push(new PANOLENS.ImagePanorama(panoramaImg[i]));

					viewer.add(panorama[i]);
					panorama[i].addEventListener('enter-fade-start', function () {
						viewer.tweenControlCenter(lookAtPositions[0], 2000);

						hideLoading();
						initedPanoram = true;

					});

				}

			}
			let panormImg = $(e.target).data('panorama')
			// get the index of the selected panorama imgs from the panoramas array
			let theindex = panoramaImg.indexOf($(this).attr('data-panorama'))


			viewer.setPanorama(panorama[theindex]);
			hideLoading()


			//	}

		}




	})
});


function showLoading() {

	$('.loading').addClass('d-flex').removeClass('d-none');


}

function hideLoading() {



	$('.loading').removeClass('d-flex').addClass('d-none');

}


let frameItem;
let itemData;

function drawSpinRotateImgs(type, color) {
	$("#mySpriteSpin").spritespin({
		source: images[type][color],
		width: 480,
		height: 350,
		sizeMode: 'fit',
		responsive: true,
		animate: false,

		onFrame: function (e, data) {
			itemData = data;
			frameItem = data.frame;
		},

		onInit: function (e, data) {



			showLoading();
			itemData = data;
			frameItem = data.frame;

		},



		onComplete: function (e, data) {



			hideLoading();

		}




	});
}



if ($("#mySpriteSpin").length > 0) {

	var type = document.querySelector(".types .active").getAttribute('data-type');
	var color = document.querySelector(".colors .active").getAttribute('data-color');
	var buttonsTypes = document.querySelectorAll("button[data-type]");
	var buttonsColors = document.querySelectorAll("span[data-color]");
	var images = [];




	for (let i = 0; i < buttonsTypes.length; i++) {
		buttonsTypes[i].addEventListener("click", function () {
			let current = document.querySelector(".types .active");
			current.className = current.className.replace("active", "");
			this.className += " active";
			type = this.getAttribute('data-type');
			drawSpinRotateImgs(type, color)
			// console.log($("#mySpriteSpin").spritespin());
		});
	}


	for (let i = 0; i < buttonsColors.length; i++) {
		buttonsColors[i].addEventListener("click", function () {
			let current = document.querySelector(".colors .active");
			current.className = current.className.replace("active", "");
			this.className += " active";
			color = this.getAttribute('data-color');
			drawSpinRotateImgs(type, color);
			setTimeout(function () {
				window.ScrollTopTo('.spritespin-instance')

			}, 200)
		});
	}




	$('.threeDWrapp .arrows .next')
		.on("click", function (e) {
			SpriteSpin.updateFrame(itemData, frameItem - 1);
		})

	$('.threeDWrapp .arrows .prev')
		.on("click", function (e) {
			SpriteSpin.updateFrame(itemData, frameItem + 1);
		})

	ajaxcall(type, color)
}

function ajaxcall(type, color) {
	var request;
	if (window.XMLHttpRequest) {
		request = new XMLHttpRequest();
	}
	let fileName = fileImages;
	request.open('GET', fileName);
	request.onreadystatechange = function () {



		if ((request.readyState === 4) && (request.status === 200)) {
			var items = JSON.parse(request.responseText);

			images = items;
			// checkLoading()
			drawSpinRotateImgs(type, color)


		}
	};
	request.send();
}







/// rotate-in-hover (car hover)

$('.rotate-in-hover .img').map((index, element) => {
	$(element).spritespin({
		source: $(element).attr("data-images").split(","),
		frameTime: 100,
		responsive: true,
		loop: false,
		animate: false,
		onComplete: function (e, data) {
			$(this).parent()
				.mouseenter(function (e) {
					SpriteSpin.startAnimation(data);
					data.reverse = false;
					data.stopFrame = data.source.length - 1
				}).mouseleave(function (e) {
					SpriteSpin.startAnimation(data);
					data.reverse = true;
					data.stopFrame = 0;
				})
			SpriteSpin.stopAnimation(data);
		}
	});

});
